<template lang="pug">
  #list-email
    .table-view
      .table-view-header
        .table-view-header-title
          .d-flex
            h3 Emails
            ModelSelect.mr-2(
              v-model="backendFilters.businessId"
              :options="businessFilterOptions"
              placeholder="-- Seleccione una empresa --"
              style="min-width: 200px"
            )
      b-container(fluid)
        b-pagination(
          v-model="backendFilters.page"
          :total-rows="countRows"
          :per-page="backendFilters.size"
          aria-controls="my-table"
        )
      b-table(:items="emails" :fields="fields" responsive)

        template(v-slot:cell(createdAt)="{value}")
          div {{value | moment('DD-MM-YYYY HH:mm')}}

        template(v-slot:cell(actions)="data")
          .table-actions
            b-button(@click="$refs.emailDetailModal.showModal({ email: data.item })" size="sm", variant="light" style="color: #7F828F")
              font-awesome-icon(:icon="['fas', 'envelope']" size="lg")
    EmailDetailModal(ref="emailDetailModal")
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import EmailDetailModal from './EmailDetailModal.vue'
import { ModelSelect } from 'vue-search-select'

export default {
  components: {
    EmailDetailModal,
    ModelSelect
  },
  data() {
    return {
      backendFilters: {
        page: 1,
        size: 30,
        businessId: undefined
      },
      countRows:30,
      fields: [
        {
          label: 'Nombre',
          key: 'business.name',
          sortable: true
        },
        {
          label: 'Asunto',
          key: 'subject',
          sortable: true
        },
        {
          label: 'Fecha',
          key: 'createdAt',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Acciones'
        }
      ]
    }
  },
  created() {
    this.listBusiness()
    this.fetchData()
  },
  watch: {
    backendFilters: {
      deep: true,
      handler () {
        this.fetchData()
      }
    }
  },
  computed: {
    ...mapGetters(['emails', 'businesses']),
    businessFilterOptions () {
      return this.businesses.map(b => { return { value: b.id, text: b.name } })
    }
  },
  methods: {
    ...mapActions(['listEmail', 'listBusiness']),
    async fetchData () {
      const response = await this.listEmail({ params: this.backendFilters })
      if (response.ok) {
        this.countRows = response.data.count
      }
    }
  }
}
</script>
